export type CompareProduct = {
  id: number
  name: string
  code: string
  price: string
  image: string
}

export class CscCompareToggleEvent extends CustomEvent<{ product: CompareProduct; checked: boolean }> {
  static type = 'csc-compare-toggle' as const

  constructor(detail: { product: CompareProduct; checked: boolean }) {
    super(CscCompareToggleEvent.type, { detail })
  }
}

export class CscCompareRemoveEvent extends CustomEvent<{ id: number }> {
  static type = 'csc-compare-remove' as const

  constructor(id: number) {
    super(CscCompareRemoveEvent.type, { detail: { id } })
  }
}

export class CscCompareClearEvent extends CustomEvent<never> {
  static type = 'csc-compare-clear' as const

  constructor() {
    super(CscCompareClearEvent.type)
  }
}

export class CscCompareRejectedEvent extends CustomEvent<{ id: number }> {
  static readonly type = 'csc-compare-rejected' as const

  constructor(id: number) {
    super(CscCompareRejectedEvent.type, { detail: { id } })
  }
}

export class CscCompareNavigateEvent extends CustomEvent<{ url: string }> {
  static readonly type = 'csc-compare-navigate' as const

  constructor(url: string) {
    super(CscCompareNavigateEvent.type, { detail: { url }, cancelable: true, bubbles: true })
  }
}
